import parseJSON from '../parseJSON';

export const setItem = (name, value) => localStorage
  && localStorage.setItem(name, JSON.stringify(value));

export const getItem = (name) => localStorage
  && parseJSON(localStorage.getItem(name));

export const deleteItem = (name) => localStorage
  && localStorage.removeItem(name);
